/**
 * Created by alex_crack on 20.11.15.
 */
require('./dist/angular-ui-notification.js');
module.exports = 'ui-notification';


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-notification/index.js
// module id = 8
// module chunks = 2